import { Media } from "./media";

export interface Speciality {
    id: number;
    name: string;
    code: string;
    description: string;
    icon: Media[];
    created_by: number;
    created_at: Date;
    changed_by: number;
    changed_at: Date;
}

export const emptySpeciality: Speciality = {
    id: 0,
    name: '',
    code: '',
    description: '',
    icon: [],
    created_by: 0,
    created_at: new Date(),
    changed_by: 0,
    changed_at: new Date()
}